var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-instructions-table',{attrs:{"endpoints":_vm.getEndpoints,"instructable-id":_vm.memberId,"instruction-types":['fulfillment', 'admin', 'delivery'],"table-id":"showMemberInstructionsTable"}})
}
var staticRenderFns = []

export { render, staticRenderFns }